import { render, staticRenderFns } from "./r-level-dialog.vue?vue&type=template&id=1b59f1b2&scoped=true"
import script from "./r-level-dialog.vue?vue&type=script&lang=js"
export * from "./r-level-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-level-dialog.vue?vue&type=style&index=0&id=1b59f1b2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b59f1b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b59f1b2')) {
      api.createRecord('1b59f1b2', component.options)
    } else {
      api.reload('1b59f1b2', component.options)
    }
    module.hot.accept("./r-level-dialog.vue?vue&type=template&id=1b59f1b2&scoped=true", function () {
      api.rerender('1b59f1b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/level/r-level-dialog.vue"
export default component.exports